import { IDocument } from "utils/interfaces/document";
import { MapDispatchToProps, connect } from "react-redux";
import {
  documentListRequest,
  documentByIdRequest,
} from "store/document/action";
import StudentDocumentsComponent, {
  StudentDocumentProps,
} from "pages/StudentDocuments";
import { IStudentDocumentContainerDispatch } from "utils/interfaces/student-dashboard";

const mapDispatchToProps: MapDispatchToProps<
  IStudentDocumentContainerDispatch,
  IDocument
> = {
  documentListRequest,
  documentByIdRequest,
};

const connector = connect(null, mapDispatchToProps);

const StudentDocuments: React.FC<StudentDocumentProps> = (props) => {
  return <StudentDocumentsComponent {...props} />;
};

export default connector(StudentDocuments);
